"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mouseOnButton = exports.ButtonEl = void 0;
require("./button.scss");
class ButtonEl {
    static render(buttonClass, name) {
        const button = document.createElement('div');
        button.className = `button ${buttonClass}`;
        button.innerText = name;
        button.title = name;
        button.id = buttonClass;
        return button;
    }
}
exports.ButtonEl = ButtonEl;
function mouseOnButton() {
    const buttons = document.querySelectorAll('.button');
    buttons.forEach((button) => {
        button.addEventListener('mouseover', () => {
            button.classList.add('focused');
        });
        button.addEventListener('mouseout', () => {
            button.classList.remove('focused');
        });
    });
}
exports.mouseOnButton = mouseOnButton;
